export default __webpack_public_path__ + "static/media/Terms of use.d586e20d.pdf";